$mol_view_tree2_to_js_test_ex_array_of_array_or_object_foo $mol_object
	complex /
		\1
		/
			true
		/
			\1
			21
		*number|string
			a 1
			str \some
